module.exports = __webpack_public_path__ + "static/media/edgar-castrejon-1SPu0KT-Ejg-unsplash.75007199.png";